"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWebSvg = exports.buildComparisonWebSvg = void 0;
const enhancements_1 = require("../enhancements");
const octagon_1 = require("./octagon");
const point_1 = require("./point");
const SIZE = octagon_1.Octagon.radius * 2 + octagon_1.Octagon.padding * 2;
const enhancements = Object.values(enhancements_1.enhancements);
// function makeWebPoints (dna: CoinPickAxeDna, maxType: WebSvgMaxType = "localMax"): IPoint[] {
//   return Octagon.radians.map((r, i) => {
//     const idx = i % enhancements.length;
//     const enhancement = enhancements[idx];
//     const max = enhancement[maxType](dna);
//     const score = (Octagon.radius / max) * enhancement.benefit(dna);
//     const offset = (Octagon.radius / max) * (max - enhancement.benefit(dna));
//     const [x, y] = [Math.sin(r) * score, Math.cos(r) * score].map(
//       (v) => v + score + offset + Octagon.padding
//     );
//     return { name: enhancement.name, x, y, max };
//   })
// }
function makeWebPoints(dnas, maxType = "localMax") {
    const points = dnas.map(() => []);
    octagon_1.Octagon.radians.forEach((r, i) => {
        const idx = i % enhancements.length;
        const enhancement = enhancements[idx];
        const max = Math.max(...dnas.map(dna => enhancement[maxType](dna)));
        return dnas.forEach((dna, i) => {
            const score = (octagon_1.Octagon.radius / max) * enhancement.benefit(dna);
            const offset = (octagon_1.Octagon.radius / max) * (max - enhancement.benefit(dna));
            points[i].push({
                max,
                name: enhancement.name,
                x: Math.sin(r) * score + score + offset + octagon_1.Octagon.padding,
                y: Math.cos(r) * score + score + offset + octagon_1.Octagon.padding,
            });
        });
    });
    return points;
}
function buildComparisonWebSvg(dna1, dna2) {
    const points = makeWebPoints([dna1, dna2], "localMax");
    const max = Math.max(points[0][0].max);
    return webSvgBase([
        webSvgChart(max),
        webSvgArea(points, [octagon_1.Octagon.primary, octagon_1.Octagon.secondary]),
        webSvgText((enhancement) => {
            const benefit = enhancement.benefitFormat(dna1);
            const comparison = enhancement.benefitComparison(dna1, dna2);
            return percentageTspan(benefit, comparison);
        }, textShiftEnds)
    ]);
}
exports.buildComparisonWebSvg = buildComparisonWebSvg;
function percentageTspan(benefit, comparison) {
    if (comparison.startsWith('0')) {
        return benefit;
    }
    const isNegative = comparison.startsWith('-');
    const options = isNegative ? octagon_1.Octagon.arrowDown : octagon_1.Octagon.arrowUp;
    return `<tspan fill="${options.color}" alignment-baseline="middle">${options.icon} ${comparison}</tspan>`;
}
function buildWebSvg(dna, maxType = "localMax") {
    const points = makeWebPoints([dna], maxType);
    const max = points[0][0].max;
    return webSvgBase([
        webSvgChart(max),
        webSvgArea(points, [octagon_1.Octagon.primary]),
        webSvgText((enhancement) => enhancement.benefitFormat(dna), textShift)
    ]);
}
exports.buildWebSvg = buildWebSvg;
function webSvgBase(content) {
    return `<svg viewBox="0 0 ${SIZE} ${SIZE}" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <style>${octagon_1.Octagon.fontSource}</style>
  </defs>
  ${[].concat(content).join(' ')}
  </svg>`
        .replace(/  /g, "")
        .replace(/\t/g, "")
        .replace(/\n/g, " ");
}
function webSvgChart(max) {
    return `<g>
    ${new Array(max).fill(0).map((d, i) => `<circle
        cx="${octagon_1.Octagon.radius + octagon_1.Octagon.padding}"
        cy="${octagon_1.Octagon.radius + octagon_1.Octagon.padding}"
        r="${((i + 1) * (octagon_1.Octagon.radius / max)).toFixed(2)}"
        stroke="${octagon_1.Octagon.lineColor}"
        stroke-width="${octagon_1.Octagon.lineStrokeWidth}"
        fill="rgba(0,0,0,0)"
      />`).join('')}
  </g>
  <g>
  ${octagon_1.Octagon.radians.map((radian, i) => {
        return `<g>
        <line
          x1="${octagon_1.Octagon.radius + octagon_1.Octagon.padding}"
          y1="${octagon_1.Octagon.radius + octagon_1.Octagon.padding}"
          x2="${(Math.sin(radian) * (octagon_1.Octagon.radius + 160) +
            octagon_1.Octagon.radius +
            octagon_1.Octagon.padding).toFixed(2)}"
          y2="${(Math.cos(radian) * (octagon_1.Octagon.radius + 160) +
            octagon_1.Octagon.radius +
            octagon_1.Octagon.padding).toFixed(2)}"
          fill="rgba(0,0,0,0)"
          stroke="${octagon_1.Octagon.lineColor}"
          stroke-width="${octagon_1.Octagon.lineStrokeWidth}"
        />
        <circle
          cx="${(Math.sin(radian) * (octagon_1.Octagon.radius + 200) +
            octagon_1.Octagon.radius +
            octagon_1.Octagon.padding).toFixed(2)}"
          cy="${(Math.cos(radian) * (octagon_1.Octagon.radius + 200) +
            octagon_1.Octagon.radius +
            octagon_1.Octagon.padding).toFixed(2)}"
          r="40"
          fill="rgba(0,0,0,0)"
          stroke="${octagon_1.Octagon.lineColor}"
          stroke-width="${octagon_1.Octagon.lineStrokeWidth}"
        />
      </g>`;
    }).join('')}
  </g>`;
}
function webSvgArea(points, options) {
    return points.map((point, i) => `<path
    d="${(0, point_1.toPath)(point)}"
    fill="${options[i % options.length].color}"
    stroke="${options[i % options.length].color}"
    fill-opacity="${options[i % options.length].opacity}"
    stroke-width="${octagon_1.Octagon.lineStrokeWidth}"
  />
  ${point.map(({ x, y, name }) => `<g transform="${`translate(${x.toFixed(2)}, ${y.toFixed(2)})`}" data-enhancement="${name}">
      <circle r="20" fill="${options[i % options.length].color}" fill-opacity="${options[i % options.length].opacity}" />
    </g>`).join('')}`).join('\n');
}
function webSvgText(getValue, shifter) {
    return octagon_1.Octagon.radians.map((radian, i) => {
        const { shiftY, textAnchor } = shifter(i % enhancements.length);
        const enhancement = enhancements[i % enhancements.length];
        const text = enhancement.name;
        return `<g transform="${`translate(${textAnchor === 'end' ? SIZE : textAnchor === 'start' ? 0 : (Math.sin(radian) * (octagon_1.Octagon.radius + 200) +
            octagon_1.Octagon.radius +
            octagon_1.Octagon.padding).toFixed(2)}, ${(Math.cos(radian) * (octagon_1.Octagon.radius + 200) +
            octagon_1.Octagon.radius +
            octagon_1.Octagon.padding +
            shiftY).toFixed(2)})`}">
        <text
          font-family="${octagon_1.Octagon.fontFamily}"
          font-weight="${octagon_1.Octagon.fontWeight}"
          font-size="${octagon_1.Octagon.textSize}"
          fill="${octagon_1.Octagon.textColor}"
          alignment-baseline="middle"
          text-anchor="${textAnchor}"
        >
          ${text}: ${getValue(enhancement)}
        </text>
      </g>`;
    }).join('');
}
function textShift(i) {
    const rotation = (360 / 8) * i;
    let shiftY = 138;
    let textAnchor = "middle";
    if (rotation >= 90 && rotation <= 235) {
        shiftY = -120;
    }
    if (rotation === 270) {
        textAnchor = "end";
    }
    if (rotation === 90) {
        textAnchor = "start";
    }
    return { shiftY, textAnchor };
}
function textShiftEnds(i) {
    const rotation = (360 / 8) * i;
    let shiftY = 138;
    let textAnchor = "middle";
    if (rotation >= 90 && rotation <= 235) {
        shiftY = -120;
    }
    if (rotation > 0 && rotation < 180) {
        textAnchor = "start";
    }
    if (rotation > 180) {
        textAnchor = "end";
    }
    return { shiftY, textAnchor };
}
//# sourceMappingURL=index.js.map